import React, {useEffect, useState, useRef} from 'react'
import {createUseStyles, useTheme} from 'react-jss'
import {useParams} from "react-router-dom";
import {Route, Switch, Redirect} from "react-router-dom";

import InvoiceEdit from "./InvoiceEdit"
//eslint-disable-next-line
const styles = createUseStyles(theme => ({
 
}));
 
const CustomerRouter = React.memo(function CustomerRouter (props) {
//eslint-disable-next-line
  const theme = useTheme();
//eslint-disable-next-line
  const classes = styles({...props, theme});
 
/***************** REFS ******************/
 
/***************** REFS ******************/
 
 
/***************** CONST ******************/
const LocationParams = useParams();
/***************** CONST ******************/
 
 
/***************** STATE ******************/
const [Id, SetId] = useState(LocationParams.id);
/***************** STATE ******************/
 
 
/***************** CALLBACK ******************/
 
/***************** CALLBACK ******************/
 
 
/***************** EFFECTS ******************/
useEffect(() => {
	
	if (LocationParams.id) {
		SetId(LocationParams.id);
	}
}, [LocationParams]);
/***************** EFFECTS ******************/
 
 
/***************** FUNCTIONS ******************/
 
/***************** FUNCTIONS ******************/
 
/***************** RENDER ******************/
  return (
	<React.Fragment>
            <Switch>
                <Route path={`/financials/purchaseordersandinvoices/invoices/invoice/${Id}/edit`}>
                    <InvoiceEdit Id={Id} RedirectToSourceOnClosing="/financials/purchaseordersandinvoices/invoices/list/all" />
                </Route>
				
                
				
            </Switch>
        </React.Fragment>
  )
 
/***************** RENDER ******************/
 
});
 
export default CustomerRouter;